module.exports = __webpack_public_path__ + "f627b4ce6fc75c9963b0c7ff38d6affb.png";